export default function Footer() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        {/* Top grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-tv-line text-background-50 text-sm"></i>
              </div>
              <span className="text-lg font-bold text-background-50">天天影视</span>
            </div>
            <p className="text-xs text-background-50/60 leading-relaxed max-w-[240px]">
              高清综艺节目在线观看平台，热门真人秀、搞笑脱口秀、娱乐视频免费在线看，天天更新不缓冲。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '首页', id: 'home' },
                { label: '最新动态', id: 'updates' },
                { label: '专题合集', id: 'index' },
                { label: '常见问题', id: 'faq' },
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => {
                      if (link.id === 'home') {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      } else {
                        scrollToSection(link.id);
                      }
                    }}
                    className="text-xs text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Content */}
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">综艺内容</h4>
            <ul className="space-y-2.5">
              {['真人秀', '脱口秀', '音乐综艺', '美食旅行', '恋爱观察'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection('cards')}
                    className="text-xs text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-50/60 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 天天影视 - 高清综艺节目在线观看平台。所有视频内容均来自互联网公开资源。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span>隐私政策</span>
            <span>用户协议</span>
            <span>免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}